import { apiClient } from '../core/apiClient'
import { getDeviceInfo } from '../../utils/deviceInfo'
import type { SignUpRequest } from './interfaces/SignUpRequest'
import type { SignInRequest } from './interfaces/SignInRequest'
import type { RefreshRequest } from './interfaces/refreshRequest'
import { AUTH_ENDPOINTS } from './endpoints'

type SignUpPayload = Omit<SignUpRequest, 'deviceInfo'>
type SignInPayload = Omit<SignInRequest, 'deviceInfo'>

/**
 * Регистрация нового пользователя
 * При работе с httpOnly куками токены устанавливаются сервером автоматически
 * 
 * @param payload - данные для регистрации
 * @returns пустой объект при успехе
 */
export async function signUp(payload: SignUpPayload): Promise<void> {
  const deviceInfo = getDeviceInfo()

  return apiClient<void>(AUTH_ENDPOINTS.signup, {
    method: 'POST',
    body: JSON.stringify({
      ...payload,
      deviceInfo,
    }),
  })
}

/**
 * Вход в систему
 * При работе с httpOnly куками токены устанавливаются сервером автоматически
 * 
 * @param payload - email и пароль
 * @returns пустой объект при успехе
 */
export async function signIn(payload: SignInPayload): Promise<void> {
  const deviceInfo = getDeviceInfo()

  return apiClient<void>(AUTH_ENDPOINTS.signin, {
    method: 'POST',
    body: JSON.stringify({
      ...payload,
      deviceInfo,
    }),
  })
}

/**
 * Выход из системы
 * Удаляет httpOnly cookies на сервере
 */
export async function signOut(): Promise<void> {
  await apiClient<void>(AUTH_ENDPOINTS.signout, {
    method: 'POST',
  })
}

/**
 * Обновление токена
 * Использует refresh_token из httpOnly cookie для получения нового access_token
 */
export async function refreshToken(): Promise<void> {
  const deviceInfoPayload: RefreshRequest = {
    deviceInfo: getDeviceInfo(),
  }

  return apiClient<void>(AUTH_ENDPOINTS.refresh, {
    method: 'POST',
    body: JSON.stringify(deviceInfoPayload),
  })
}
